import { useEffect, useState } from "react";
import { getCategoryBySlug, getPostsByCategory, WPPost, WPCategory } from "../content/contentClient";

type UseWPCategoryPostsResult = {
  posts: WPPost[];
  loading: boolean;
  error: boolean;
  categoryName?: string;
  category?: WPCategory;
};

export default function useWPCategoryPosts(
  slug?: string,
  perPage = 12,
  lang?: string
): UseWPCategoryPostsResult {
  const [posts, setPosts] = useState<WPPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [categoryName, setCategoryName] = useState<string | undefined>(undefined);
  const [category, setCategory] = useState<WPCategory | undefined>(undefined);

  useEffect(() => {
    if (!slug) {
      setError(true);
      setLoading(false);
      return;
    }

    let active = true;

    const load = async () => {
      setLoading(true);
      setError(false);
      try {
        const category = await getCategoryBySlug(slug, lang);
        if (!category) throw new Error("Category not found");
        if (active) {
          setCategoryName(category.name);
          setCategory(category);
        }
        const data = await getPostsByCategory(category.id, perPage, lang);
        if (active) setPosts(data || []);
      } catch {
        if (active) {
          setError(true);
          setPosts([]);
          setCategory(undefined);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [slug, perPage, lang]);

  return { posts, loading, error, categoryName, category };
}
